import { getSprite } from "../../framework/src/modules/Sprite";
import { EASE, getTweenAsync } from "../../framework/src/modules/Tween";
import BaseAnimSprite from "../Animations/BaseAnimSprite";
import Multiplier from "../Animations/Multiplier";
import BaseSymbol from "./BaseSymbol";
import * as PIXI from "pixi.js-legacy";

export default class SpecialSymbol extends BaseSymbol {

    animatedSprite: BaseAnimSprite; // PIXI.AnimatedSprite;
    multiplier: Multiplier; // PIXI.Sprite;    
    shine: PIXI.Sprite;

    constructor(symbolName: string, index: number, blur: boolean = false) {
        super(symbolName, index, blur);
    }

    // if undefined , create sprite2 , effect , particles and add them to the symbol/"container"
    // !!! multiplier animation is triggered by winController !!!
    async create(multiplie: number) {

        if ( multiplie > 1 ) {            
            if (this.fireBack === undefined){
                this.createFireBack();
            } else { console.error(" fireBack not created !"); }
        }

        if ( this.shine == undefined ) {
            let tempName = "shine_" + this.symbolName.substr("symbol_".length).toLowerCase()+".png";
            this.shine = getSprite(tempName, 0, 0);            
        } else { console.error(" special symbol > shine sprite not created "); }

        if ( this.animatedSprite == undefined ) {
            this.animatedSprite = new BaseAnimSprite( this.name );
            this.animatedSprite.animationSpeed = 0.25; // 0.33;//2.5 / 10;
        } else { console.error(" special symbol > animated sprite not created", this.name ,  this ); }

        this.addChild(this.shine, this.animatedSprite);

        if ( multiplie > 1 ) {
            this.multiplier = new Multiplier( multiplie );
            this.addChild( this.multiplier );
        }
    }

    async clear() {
        
        if ( this.fireBack != undefined ){
            this.clearFireBack();
        }

        this.sprite.visible = true;
        this.sprite.alpha = 1;

        if ( this.shine != undefined ) {
            this.shine.visible = false;
            this.shine.destroy({children:true, baseTexture:true});
            this.shine = undefined;
        }

        if ( this.animatedSprite != undefined ) {
            this.animatedSprite.stop();
            this.animatedSprite.visible = false;            
            this.animatedSprite.destroy({children:true, baseTexture:true});
            this.animatedSprite = undefined;
        }

        if ( this.multiplier != undefined ) {
            this.multiplier.visible = false;
            this.multiplier.destroy({children:true, baseTexture:true});
            this.multiplier = undefined;
        }

        // this.removeChildren();
        this.addChild(this.sprite);        
    } 
    
    async shineAnimation(){
        getTweenAsync(this.shine, {angle: 90}, 1000, EASE.LINEAR);
        // await getTweenAsync(this.shine.scale , {x:1.1,y:1.1} ,500, EASE.BACK_O);
        // getTweenAsync(this.shine.scale , {x:1,y:1} ,500, EASE.BACK_I);
    }

    async play() {
        
        if ( this.multiplier !== undefined ) {
            this.playFireBack();
        }        
        
        this.shineAnimation();
        this.sprite.visible = false;
        await this.animatedSprite.animate();
        
        this.animatedSprite.resetAnimation();

        this.shine.visible = false ;
        this.sprite.visible = true ;       
    }
}